module.exports = SharedDependencies.MobX['task-hub'];